import React from 'react';
import { motion } from 'framer-motion';
export function ValueStack() {
  const stackItems = [{
    emoji: '📖',
    title: 'El Blueprint Bio-X 90 (60+ páginas)',
    val: '$197'
  }, {
    emoji: '📱',
    title: 'App Interactiva BIO-X 90 con protocolo de 30 días',
    val: '$297'
  }, {
    emoji: '🛒',
    title: 'BONO #1: La Despensa del Ejecutivo Bio-X',
    val: '$67'
  }, {
    emoji: '🚨',
    title: 'BONO #2: Protocolos de Emergencia Bio-X (7 tarjetas)',
    val: '$87'
  }, {
    emoji: '📋',
    title: 'BONO #3: El Scorecard Bio-X (auditoría 5 min)',
    val: '$57'
  }, {
    emoji: '💊',
    title: 'La Matriz de Suplementos Bio-X',
    val: '$97'
  }, {
    emoji: '🧰',
    title: 'Calculadoras Interactivas (Ayuno, Frío, Score)',
    val: '$97'
  }, {
    emoji: '🏆',
    title: 'Sistema de Gamificación (Rachas, Badges, XP)',
    val: '$47'
  }, {
    emoji: '📊',
    title: 'Tracker de Progreso con Gráficos de Tendencia',
    val: '$97'
  }, {
    emoji: '🔄',
    title: 'Actualizaciones de por vida del protocolo',
    val: '$197'
  }];
  return <section className="py-24 px-6 bg-brand-bg" data-id="element-770">
      <div className="max-w-[800px] mx-auto" data-id="element-771">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-772">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-773">
            Todo Lo Que Recibes Hoy — Por Una Fracción de Su Valor Real
          </h2>
        </motion.div>

        <div className="bg-brand-card rounded-[24px] p-6 md:p-10 border border-brand-border shadow-xl mb-12" data-id="element-774">
          <div className="space-y-4" data-id="element-775">
            {stackItems.map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: idx * 0.05
          }} className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-4 group" data-id="element-776">
                <div className="flex items-center gap-3" data-id="element-777">
                  <span className="text-xl" data-id="element-778">{item.emoji}</span>
                  <span className="font-bold text-white group-hover:text-brand-cyan transition-colors" data-id="element-779">
                    {item.title}
                  </span>
                </div>
                <div className="hidden sm:block flex-1 border-b-2 border-dotted border-brand-border mx-4 opacity-50" data-id="element-780" />
                <div className="sm:text-right shrink-0" data-id="element-781">
                  <span className="text-brand-muted font-mono" data-id="element-782">
                    Valor: {item.val}
                  </span>
                </div>
              </motion.div>)}
          </div>

          <div className="my-10 h-px w-full bg-gradient-to-r from-transparent via-brand-border to-transparent" data-id="element-783" />

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-center" data-id="element-784">
            <p className="text-2xl md:text-3xl text-brand-muted line-through mb-6 font-mono" data-id="element-785">
              VALOR TOTAL: $1,236
            </p>

            <p className="text-xl text-white font-medium mb-2" data-id="element-786">PRECIO HOY:</p>
            <div className="flex justify-center items-end gap-2 mb-2" data-id="element-787">
              <span className="text-6xl md:text-7xl font-display font-bold text-brand-gold drop-shadow-[0_0_20px_rgba(255,215,0,0.3)] leading-none" data-id="element-788">
                $6.36
              </span>
              <span className="text-brand-muted font-medium pb-2" data-id="element-789">USD</span>
            </div>
            <p className="text-brand-muted text-sm mb-6" data-id="element-790">
              Pago único. Acceso de por vida.
            </p>

            <div className="inline-block bg-gradient-to-r from-brand-red/20 to-brand-red/10 border border-brand-red/30 text-white font-bold px-6 py-2 rounded-full text-sm mb-10" data-id="element-791">
              Ahorras $1,229 (descuento del 99%)
            </div>

            <a href="https://pay.hotmart.com/X105898119V" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full h-[72px] rounded-2xl bg-brand-gold text-black font-black text-lg md:text-xl hover:scale-[1.03] transition-transform duration-300 shadow-[0_0_30px_rgba(255,215,0,0.3)] hover:shadow-[0_0_50px_rgba(255,215,0,0.5)] mb-4" data-id="element-792">
              QUIERO MI ACCESO COMPLETO POR SOLO $6.36 →
            </a>

            <p className="text-xs text-brand-muted mb-6" data-id="element-793">
              🔒 Pago 100% seguro con Stripe · Acceso inmediato · Garantía 60
              días
            </p>

            {/* Payment Logos */}
            <div className="flex flex-wrap justify-center items-center gap-3 md:gap-6 text-xs font-bold text-brand-muted/60 uppercase tracking-wider" data-id="element-794">
              <span className="px-3 py-1 bg-brand-bg rounded border border-brand-border" data-id="element-795">
                Visa
              </span>
              <span className="px-3 py-1 bg-brand-bg rounded border border-brand-border" data-id="element-796">
                Mastercard
              </span>
              <span className="px-3 py-1 bg-brand-bg rounded border border-brand-border" data-id="element-797">
                PayPal
              </span>
              <span className="px-3 py-1 bg-brand-bg rounded border border-brand-border" data-id="element-798">
                Stripe
              </span>
              <span className="px-3 py-1 bg-brand-bg rounded border border-brand-border text-brand-cyan/70" data-id="element-799">
                🔒 SSL Seguro
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}